import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

import { ToastContainer } from "react-toastify";
import Hotjar from "@hotjar/browser";
import { useEffect } from "react";
import { AppRoutes } from "routes";
import { ModalProvider } from "@shared/contexts/modal-context";

if (process.env.REACT_APP_BRAND === "nomad") {
  require("./App.nomad.scss");
} else {
  require("./App.scss");
}

function App() {
  const setFavicon = (brand?: string) => {
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (link) {
      switch (brand) {
        case "rockets":
          link.href = "/rockets-favicon.ico";
          break;
        default:
          link.href = "/favicon.ico";
      }
    }
  };

  useEffect(() => {
    setFavicon(process.env.REACT_APP_BRAND);
    if (process.env.REACT_APP_ENV === "production") {
      Hotjar.init(
        Number(process.env.REACT_APP_HOTJAR_ID),
        Number(process.env.REACT_APP_HOTJAR_SNIPPET_VERSION),
      );
    }
  }, []);

  return (
    <ModalProvider>
      <BrowserRouter>
        <div>
          <AppRoutes />
          {/* <ScrollToTop /> */}
          <ToastContainer />
        </div>
      </BrowserRouter>
    </ModalProvider>
  );
}

export default App;
